<template>
  <div class="news" v-if="noticeInfo">
    <div class="renew3_wrapper">
      <p class="news_text">
        お知らせ｜<a
          :href="noticeInfo.linkurl"
          target="_blank"
          v-if="String(noticeInfo.linktarget) === '1'"
          class="news_link"
          >{{ noticeInfo.contexts }}</a
        ><a :href="noticeInfo.linkurl" v-else class="news_link">{{
          noticeInfo.contexts
        }}</a>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * トップの1行お知らせ帯。varuna から取った先頭1件だけ出す。
 *
 * Top.vue（1,700行超）の分解で切り出した。取得も表示もこの中で完結する。
 *
 * ⚠️ 中身はビルド時に存在しない API 取得コンテンツなので、Top.vue 側では
 * <!-- static:skip --> で囲んで静的トップ(public/top-content.html)から外す。
 */
import axios from 'axios'
import { getCurrentInstance, onMounted, ref } from 'vue'

type NoticeInfo = {
  linkurl: string
  /** '1' なら別タブで開く。API は文字列/数値どちらも返しうる */
  linktarget: string | number
  contexts: string
}

type VarunaClient = { endPoints: { getNoticeinformation: string } }

const varuna = (
  getCurrentInstance()!.proxy as unknown as { $varuna: VarunaClient }
).$varuna

const noticeInfo = ref<NoticeInfo | null>(null)

onMounted(() => {
  axios
    .post(varuna.endPoints.getNoticeinformation, new FormData(), {
      timeout: 60000
    })
    .then((response) => {
      const noticeList = response.data && response.data.notice_list
      if (noticeList) {
        noticeInfo.value = (Object.values(noticeList)[0] as NoticeInfo) || null
      }
    })
    .catch((error) => {
      // 取れなくてもトップは出す（v-if で丸ごと消える）
      console.error('お知らせの取得エラー', error)
    })
})
</script>

<style scoped>
.renew3_top .news {
  margin-bottom: 12px;
}

.renew3_top .news_text {
  border: 1px solid #0f9934;
  border-radius: 10px;
  padding: 10px;
  font-size: 12px;
}
</style>
